import Vue from 'vue';
import VueRouter from 'vue-router';
import { G2S } from 'core/g2s';
import * as auth from 'core/auth';
import moment from 'moment';
import AccountDeleteComponent from './views/account/delete';
import AccountViewComponent from './views/account';
import AccountPasswordNewComponent from './views/account/password/new';
import AccountProductsBuyComponent from './views/account/products/buy';
import AccountProductsBuyOrderComponent from './views/account/products/buy/order';
import AccountConfirmemailComponent from './views/account/confirmemail';
import AccountWelcomeComponent from './views/account/welcome';
import AccountUnsubscribeComponent from './views/account/unsubscribe';
import AuthBySMSComponent from './views/auth/sms';
import HyggeComponent from './views/hygge';
import OrderBookingProductComponent from './views/order/booking/product';
import OrderComponent from './views/order';
import OrderPaymentComponent from './views/order/payment';
import OrderViewComponent from './views/order/view';
import SupportNewComponent from './views/support/new';
import SupportFeedbackComponent from './views/support/feedback';
import SupportListComponent from './views/support/list';
import SupportAllrequestsComponent from './views/support/allrequests';
import FlightsSearchResultsComponent from './views/flights/search-results';
import FlightsBookingComponent from './views/flights/booking';
import PartnerComponent from './views/partner';
import RefundApplicationComponent from './views/support/refund-application';

Vue.use(<any>VueRouter);

export const router = new VueRouter(<any>{
    mode: 'history',
    routes: [
        { path: '/account/delete', component: AccountDeleteComponent, meta: { gaTitle: 'Account / Delete' } },
        { path: '/account/confirmemail', component: AccountConfirmemailComponent, meta: { gaTitle: 'Account / Confirmemail' } },
        { path: '/account/password/new', component: AccountPasswordNewComponent, beforeEnter: auth.AuthService.routeAnonymousOnly, meta: { gaTitle: 'Password / New' } },
        { path: '/account/sms', component: AuthBySMSComponent, meta: { gaTitle: 'Products / Buy' } },
        { path: '/account/products/buy', component: AccountProductsBuyComponent, meta: { gaTitle: 'Products / Buy' } },
        { path: '/account/products/buy/:orderGuid', component: AccountProductsBuyOrderComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, props: true, meta: { gaTitle: 'Products / Buy / Order' } },
        { path: '/account/welcome', component: AccountWelcomeComponent, beforeEnter: auth.AuthService.routeAuthenticatedOnly, meta: { gaTitle: 'Account / Welcome' } },
        { path: '/account/unsubscribe', component: AccountUnsubscribeComponent, meta: { gaTitle: 'Account / Unsubscribe' } },
        // Do not move /account route up before other account routes!
        { path: '/account', component: AccountViewComponent, meta: { gaTitle: 'Account' } },
        { path: '/flights/booking/:searchId/:flightId', component: FlightsBookingComponent, props: true, meta: { gaTitle: 'Flights / Booking' } },
        { path: '/flights/:searchFrom/:searchTo/:searchDate/:searchPassengers/:searchClass/:searchFilters?', name: 'flightSearch', component: FlightsSearchResultsComponent, props: true, meta: { gaTitle: 'Flights / Search results' } },
        { path: '/flights/:searchFrom/:searchTo/:searchDate/:searchPassengers/:searchClass/booking/:searchId/:flightId', name: 'flightBooking', component: FlightsBookingComponent, props: true, meta: { gaTitle: 'Flights / Booking' } },
        { path: '/flights/:searchFrom/:searchTo/:searchDate/:searchFrom2/:searchTo2/:searchDate2/:searchPassengers/:searchClass/:searchFilters?', name: 'flightSearchRoundtrip', component: FlightsSearchResultsComponent, props: true, meta: { gaTitle: 'Flights / Search results' } },
        { path: '/flights/:searchFrom/:searchTo/:searchDate/:searchFrom2/:searchTo2/:searchDate2/:searchPassengers/:searchClass/booking/:searchId/:flightId', name: 'flightBookingRoundtrip', component: FlightsBookingComponent, props: true, meta: { gaTitle: 'Flights / Booking' } },
        { path: '/flights/archive/:searchGuid', name: 'flightSearchArchive', component: FlightsSearchResultsComponent, props: true, meta: { gaTitle: 'Flights / Search results archive' } },
        {
            path: '/flights/:searchFrom/:searchTo/:searchFilters?', redirect: route => {
                route.params.searchFrom2 = route.params.searchTo;
                route.params.searchTo2 = route.params.searchFrom;
                route.params.searchDate = moment().add(7, 'd').format('MMDD');
                route.params.searchDate2 = moment().add(14, 'd').format('MMDD');
                route.params.searchClass = 'e';
                route.params.searchPassengers = '100';

                return '/flights/:searchFrom/:searchTo/:searchDate/:searchFrom2/:searchTo2/:searchDate2/:searchPassengers/:searchClass/:searchFilters?';
            }
        },
        { path: '/hygge', component: HyggeComponent, meta: { gaTitle: 'Hygge' } },
        { path: '/order/booking/product/:orderGuid/:productId', component: OrderBookingProductComponent, props: true, meta: { gaTitle: 'Order / Booking / Product' } },
        { path: '/order/payment/:orderGuid/:billPublicId?', name: 'order-payment', component: OrderPaymentComponent, props: true, meta: { gaTitle: 'Order / Payment' } },
        { path: '/order/:orderGuid', component: OrderViewComponent, props: true, meta: { gaTitle: 'Order / View' } },
        { path: '/order/:orderGuid/tickets', redirect: route => {
            let url = G2S.config.apiUrl
                + '/api/Reservation/GetTickets?reservationPublicId='
                + route.params.orderGuid;

            if (route.query.culture) {
                url += '&culture=' + route.query.culture;
            }

            window.location.href = url;
        }},
        { path: '/order', component: OrderComponent, meta: { gaTitle: 'My Order' } },
        { path: '/refund-application/:publicId', component: RefundApplicationComponent, props:true, meta: { gaTitle: 'Support / Refund Application' } },
        { path: '/support', redirect: () => {
            window.location.href = '/help';
        }},
        { path: '/support/new/:orderNumber?', component: SupportNewComponent, props: true, meta: { gaTitle: 'Support / New' } },
        { 
            path: '/support/feedback/', 
            component: SupportFeedbackComponent, 
            beforeEnter: (to, from, next) => {
                if (!to.query.zd_support_ticket_id || !to.query.zd_support_ticket_score) {
                    window.location.href = '/';
                }
                next();
            },
            props: true,
            meta: { gaTitle: 'Support / Feedback' } 
        },
        { path: '/support/list', component: SupportListComponent, meta: { gaTitle: 'Support / List' } },
        { path: '/support/allrequests', component: SupportAllrequestsComponent, meta: { gaTitle: 'Support / Allrequests' } },
        {
            path: '/partner',
            component: PartnerComponent,
            props: (route) => ({
                searchId: route.query.sid,
                flightId: route.query.fid,
                partnerName: route.query.pn,
                externalPartnerId: route.query.epid,
                externalSearchId: route.query.esid,
                externalFlightId: route.query.efid,
                externalFlightBillingPrice: route.query.efbp
            }),
            meta: { gaTitle: 'Partner' }
        }
    ]
});

router.afterEach((to) => {
    (<any>Vue).prototype.$ga.sendPageview(to.fullPath, to.meta.gaTitle ? to.meta.gaTitle : window.document.title);
});

export default router;
